import { motion } from "framer-motion";
import { useLang } from "../i18n";

const WHATSAPP_NUMBER = "393331991118";

const ENTRANCE = {
  initial: { opacity: 0, scale: 0.6, y: 20 },
  animate: { opacity: 1, scale: 1, y: 0 },
  transition: { delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  whileHover: { scale: 1.08 },
  whileTap: { scale: 0.95 },
};

const WhatsAppIcon = () => (
  <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
    <path d="M16.004 4.667c-6.253 0-11.337 5.084-11.337 11.337 0 2.0.523 3.953 1.517 5.675L4.667 27.333l5.788-1.485a11.28 11.28 0 0 0 5.545 1.452h.005c6.252 0 11.336-5.084 11.336-11.337 0-3.028-1.179-5.876-3.32-8.017a11.26 11.26 0 0 0-8.017-3.279zm0 20.72h-.004a9.4 9.4 0 0 1-4.788-1.311l-.343-.204-3.435.881.918-3.349-.224-.344a9.37 9.37 0 0 1-1.442-5.019c0-5.199 4.231-9.43 9.435-9.43 2.519 0 4.887.982 6.667 2.764a9.37 9.37 0 0 1 2.76 6.671c-.003 5.199-4.234 9.34-9.544 9.34zm5.172-7.058c-.283-.142-1.676-.827-1.936-.921-.26-.095-.449-.142-.638.141-.188.284-.732.921-.897 1.11-.165.19-.33.213-.614.071-.283-.142-1.196-.441-2.278-1.406-.842-.751-1.41-1.679-1.576-1.962-.165-.284-.018-.437.124-.578.128-.127.284-.331.425-.497.142-.165.189-.284.284-.473.094-.19.047-.355-.024-.497-.07-.142-.637-1.536-.873-2.104-.23-.552-.464-.477-.638-.486l-.543-.01a1.04 1.04 0 0 0-.756.355c-.26.284-.992.97-.992 2.364 0 1.395 1.016 2.742 1.157 2.932.142.189 1.998 3.05 4.84 4.277.677.292 1.204.466 1.616.597.679.216 1.296.185 1.784.112.544-.081 1.676-.685 1.912-1.347.236-.663.236-1.23.165-1.348-.07-.118-.26-.19-.543-.331z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { t } = useLang();
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(t.whatsapp.prefill)}`;
  return (
    <motion.a
      data-testid="whatsapp-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp.label}
      {...ENTRANCE}
      className="group fixed bottom-6 left-6 z-[80] flex items-center gap-0 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.4)] hover:shadow-[0_10px_30px_rgba(37,211,102,0.55)] transition-shadow duration-300"
    >
      <span className="flex h-14 w-14 items-center justify-center shrink-0">
        <WhatsAppIcon />
      </span>
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium tracking-wide group-hover:max-w-[180px] group-hover:pr-5 transition-[max-width,padding] duration-500 ease-out">
        {t.whatsapp.label}
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
